<template>
    <v-dialog max-width="500px" v-model="show">
        <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>
        <v-card>
            <v-toolbar flat dark color="panel1">
                <v-toolbar-title>New Model</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="show=false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="pa-5">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-form ref="mainForm">
                            <v-text-field 
                                label="Code" 
                                outlined
                                dense
                                v-model="form.em_code"
                                v-if="show" autofocus  
                            ></v-text-field>
                            <v-text-field 
                                label="Name" 
                                outlined
                                dense
                                v-model="form.em_name"  
                            ></v-text-field>
                            <v-menu v-model="dpicker.menu1" :close-on-content-click="false" max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        dense
                                        :value="form.start_date"
                                        label="Start Date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="form.start_date" @change="dpicker.menu1 = false"></v-date-picker>
                            </v-menu>
                            <v-menu v-model="dpicker.menu2" :close-on-content-click="false" max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        dense
                                        :value="form.end_date"
                                        label="End Date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="form.end_date" @change="dpicker.menu2 = false"></v-date-picker>
                            </v-menu>

                            
                        </v-form>
                    </v-col>
                </v-row>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="cbtnSave" dark @click="save">
                    <v-icon left dark>mdi-check</v-icon>
                    Submit
                </v-btn>
                <v-btn class="ml-2" color="cbtnRed" dark @click="show=false">
                    <v-icon left dark>mdi-close</v-icon>
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
import DlgMessage from '@/components/DlgMessage'
import ApEarnedService from '@/services/ApEarnedService'
import moment from 'moment'
export default {
    name: "DlgModelAdd",
    props: {
        visible:Boolean,
    },      
    components:{DlgMessage},
    computed: {
      show: {
        get () {
          return this.visible
        },
        set (value) {
           if (!value) {
                this.$emit('close')
           }
        }
      },
      
    },      
    data() {
    return {
        
      message: "",
      customer_id:0,
      form:{
            
            login_id:"",
            sequence:0,
            em_code:"",
            em_name:"",
            em_type_code:1,
            earned_campaign_id:0,
            purchase_amount:0,
            purchase_quantity:0,
            points_earned:0,
            percentage:0,
            calc_type_code:"ratio",
            prod_code:"",
            transaction_type_code:"any",
            count_max_limit:0,
            amt_min:0,
            amt_max:999999,
            start_date:"",
            end_date:"",
            start_time:"00:00:00",
            end_time:"23:59:59",
            day_monday:1,
            day_tuesday:1,
            day_wednesday:1,
            day_thursday:1,
            day_friday:1,
            day_saturday:1,
            day_sunday:1,
            status:"ACTIVE",            
          },
        dataList:[],
        dpicker:{menu1: false,menu2: false,},
        respCode:0,
    //   rules: {
    //         required: value => !!value || 'Required.',
    //         counter: value => value.length == 6 || 'Need 6 digit',
    //         digit: value=> /[0-9][0-9][0-9][0-9][0-9][0-9]/.test(value) || 'Number only',
    //   },
    };
  },
  async created(){
      this.form.start_date = moment(String(new Date())).format('YYYY-MM-DD');
      this.form.end_date = moment(String(new Date())).format('YYYY-MM-DD');
  },
  mounted(){
        this.form.start_date = moment(String(new Date())).format('YYYY-MM-DD');
        this.form.end_date = moment(String(new Date())).format('YYYY-MM-DD');

  },
  methods: {
    dlgShow(){
    },
    dlgClose(){
        //console.log(this.respCode);
        
        if(this.respCode == 200){
            this.form.c_code = "";
            this.form.c_name = "";
            this.form.sequence = 0;
            this.show = false;
        }
            
    },
    async save(){
        if(this.$refs.mainForm.validate()) {
            let title = "New Pts Model"
            try{
                ApEarnedService.insert_earned_model(this.form).then((res) => {
                    //console.log(res);
                    this.respCode = res.status;
                    this.$refs.dlgMsg.showDlgBox(true,'success',title,'Success.');
                }).catch((e)=>{
                    //console.log(e.response);
                    this.respCode = e.response.status;
                    if(e.response.data.error_message)
                        this.$refs.dlgMsg.showDlgBox(true,'error',title,e.response.data.error_message);
                })
                ;
            } catch(e) {
                if(e)
                    this.$refs.dlgMsg.showDlgBox(true,'error',title,'Unknown Error');
            }            
        }
    },

  }
};

</script>
